/* eslint-disable vue/no-use-v-if-with-v-for */
<template>
  <a-skeleton :loading="loading" active :paragraph="{ rows: 8 }">
    <div class="container">
      <a-spin :spinning="spinning">
        <a-tabs @change="tabChange" :animated="false">
          <a-tab-pane v-for="(tab, key) in dataGroup" :key="key" class="tab-content">
            <div slot="tab">
              {{ key | tabTitle }}
            </div>
            <div v-if="userInfo.authentication_status == '2'">
              <a-row v-if="dataGroup[key].list.length > 0" type="flex" style="height: 100%">
                <a-col :span="24">
                  <a-row v-if="tab && tab.list.length > 0" class="texture-list">
                    <a-col
                      :sm="12"
                      :md="8"
                      :xl="6"
                      :xxl="4"
                      v-for="(item, index) in tab.list"
                      :key="item.id">
                      <div class="texture-item">
                        <div
                          class="cover"
                          :class="{ 'card-cover': item.category == '3' && item.image }"
                          @click="clickItem(item)"
                        >
                          <img
                            :class="{ 'card-image': item.category == '3' }"
                            v-if="item.image"
                            :src="`${domainMap[item.category]}${item.image}`"
                            alt=""
                          />
                          <img
                            class="card-bg"
                            v-if="item.category == '3' && item.image"
                            :src="`${domainMap[item.category]}${item.image}`"
                            alt=""
                          />
                          <div class="mask" v-if="item.status == '0' || item.status == '3'">
                            <span class="del-btn close-icon" @click.stop="showDeleteConfirm(index)"> </span>
                          </div>
                        </div>
                        <div class="sort">
                          <!-- <a-icon type="tag" rotate="270" style="color:#999999"/> -->
                          <span class="icon-icon_label_16" style="color: #bbbbbbbb"></span>
                          <span class="sort_name">{{ categoryMaps[item.category] }}</span>
                        </div>
                        <div class="name">{{ item.title }}</div>
                        <div class="price">价格：<span>{{ item.recommended_retail_price ? item.recommended_retail_price + '钻石' : '-' }}</span></div>
                        <div class="copyright">分成比例：<!--
                        --><span v-if="item.copyright_type == '1'">版权归画师-非独家 画师分成70%</span>
                          <span v-else-if="item.copyright_type == '2'">版权归画师-独家 画师分成80%</span>
                          <span v-else-if="item.copyright_type == '3'">版权归漫想 画师分成90%</span>
                          <span v-else>-</span>
                        </div>
                        <div class="status" :class="{ error: item.status === '3' }">
                          <!-- <a-tooltip
                            placement="topLeft"
                            :title="item.status == 3 ? item.status_desc : ''"
                            arrow-point-at-center
                          > -->
                          <div class="status-button">
                            <a-badge :status="statusMap[item.status].status" :text="statusMap[item.status].text" />
                          </div >

                          <!-- </a-tooltip> -->
                          <template v-if="item.status == 3">
                            <a-tooltip
                              placement="top"
                              :title="item.status == 3 ? item.status_desc : ''"
                              trigger="hover"
                            >
                              <template>
                                <span class="icon-left_help_16 errorIcon font_family"></span>
                              </template>
                            </a-tooltip>
                          </template>

                          <a-popconfirm
                            title="确定撤回这条审核？"
                            @confirm="revokeAudit(item.id)"
                            v-if="item.status == 1"
                          >
                            <a-button class="back-button" size="small" icon="left">撤回</a-button>
                          </a-popconfirm>
                        </div>
                      </div>
                    </a-col>
                  </a-row>
                  <div v-else class="empty-status">
                    <a-empty>
                      <span slot="description"> 没有此类型数据！ </span>
                    </a-empty>
                  </div>

                  <div v-if="tab.list.length > 0" class="pagination">
                    <a-pagination
                      :current="tab.currentPage"
                      :total="dataGroup[key].total"
                      :default-page-size="12"
                      :show-total="(total) => `共 ${Math.ceil(total / 12)} 页`"
                      @change="allPageChange"
                    />
                  </div>
                </a-col>
              </a-row>
              <div v-else class="empty-status">
                <a-empty :imageStyle="{ display: 'none' }">
                  <!-- <span
                    slot="description"
                    v-if="activeTab == 1"
                    style="font-size: 18px;color: #999999;">
                    服务器系统升级中，升级期间部分页面和功能暂停服务。已经提交成功的场景类素材包，无需重复上传，问题修复后即可正常展示。
                  </span> -->
                  <span slot="description"> 您还没有上传过任何素材，点击下方可按钮，可进行上传操作哦~ </span>
                  <a-button type="primary" style="margin-top: 24px" @click="jumpToEditor()">上传</a-button>
                </a-empty>
              </div>
            </div>
            <div v-else style="padding: 0 24px">
              <div v-if="userInfo.authentication_status == '0'" class="notice">
                认证画师后，就可以上传自己的作品喽，快来认证吧~ <br /><a-button
                  @click="goAuthor"
                  type="primary"
                  style="padding: 0 24px; margin-top: 40px"
                >去认证</a-button
                >
              </div>
              <div v-if="userInfo.authentication_status == '1'" class="notice">
                审核同学正在疯狂审查中，我们会在三个工作日内以短信方式通知您审核结果，请耐心等待审核结果 <br /><a-button
                  type="primary"
                  style="padding: 0 24px; margin-top: 40px"
                >审核中</a-button
                >
              </div>
              <div v-if="userInfo.authentication_status == '3'" class="notice">
                {{ `${userInfo.authentication_status_desc}， 请重新上传` }}<br /><a-button
                  @click="goAuthor"
                  type="primary"
                  style="padding: 0 24px; margin-top: 40px"
                >重新认证</a-button
                >
              </div>
            </div>
          </a-tab-pane>

          <a-dropdown slot="tabBarExtraContent" style="margin-right: 20px">
            <a class="ant-dropdown-link" @click="(e) => e.preventDefault()">
              {{ dataGroup[activeTab].activeStatus | statusMenu }}
              <a-icon type="down" />
            </a>
            <a-menu slot="overlay" @click="statusChange">
              <a-menu-item v-for="item in statusList" :key="item">
                <a href="javascript:;">{{ item | statusMenu }}</a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
          <a-button
            slot="tabBarExtraContent"
            type="primary"
            icon="cloud-upload"
            style="margin-right: 20px"
            :disabled="userInfo.authentication_status != '2'"
            @click="jumpToEditor()"
          >上传</a-button
          >
        </a-tabs>
      </a-spin>
      <a-modal
        v-model="showItemModal"
        centered
        title="素材详情"
        :footer="null"
        class="itemModal"
        :width="activeItem.category == '3' ? 393 : 912"
        :bodyStyle="{ padding: '24px 8px 24px 24px' }"
      >
        <span class="close-modal-icon" slot="closeIcon"></span>
        <div v-if="activeItem.category == '3'">
          <a-checkbox @change="onCardPosChange" style="margin-bottom: 24px">
            <span style="color: #999999; font-size: 12px">显示信息框位置</span>
          </a-checkbox>
          <div class="card-preview">
            <img style="z-index: 1" :src="`${domainMap[activeItem.category]}${activeItem.image}`" alt="" />
            <img style="z-index: 2" v-if="showCardPos" src="@/assets/img/img_card_pos.png" alt="" />
          </div>
        </div>
        <div class="package-wrapper" v-else>
          <package-list :activeItem="activeItem"></package-list>
        </div>
      </a-modal>
    </div>
  </a-skeleton>
</template>

<script>
import { LeftOutlined } from '@ant-design/icons-vue';
import packageList from '@/components/Zpace/packageList/packageList'
const categoryMaps = {
  1: '场景',
  2: '贴图',
  3: '人设背景'
}
const statusMap = {
  0: {
    text: '未提交',
    status: 'default'
  },
  1: {
    text: '审核中',
    status: 'processing'
  },
  2: {
    text: '审核成功',
    status: 'success'
  },
  3: {
    text: '审核失败',
    status: 'error'
  }
}

export default {
  components: { packageList },
  filters: {
    statusMenu (val) {
      let text = ''
      val = val - 0
      switch (val) {
        case 0:
          text = '全部'
          break
        case 1:
          text = '未提交'
          break
        case 2:
          text = '审核中'
          break
        case 3:
          text = '审核失败'
          break
        case 4:
          text = '审核成功'
          break
        default:
          break
      }
      return text
    },
    tabTitle (val) {
      let text = ''
      switch (val) {
        case '0':
          text = '全部'
          break
        case '1':
          text = '场景'
          break
        case '2':
          text = '贴图'
          break
        // case '3':
        //   text = '人设背景'
        //   break
      }
      return text
    }
  },
  data () {
    return {
      domainMap: {
        1: this.constv.QINIU_IMAGE_CND_URL,
        2: this.constv.QINIU_IMAGE_CND_URL,
        3: this.constv.QINIU_IMAGE_QNC_CDN_URL
      },
      categoryMaps,
      visible: false,
      statusMap,
      activeTab: '0',
      delIndex: '',
      loading: false,
      dataGroup: {
        0: {
          activeStatus: 0,
          currentPage: 1,
          pageSize: 12,
          list: [], // 显示数据
          total: [] // 当前类型的总共数据
        },
        1: {
          activeStatus: 0,
          currentPage: 1,
          pageSize: 12,
          list: [],
          total: []
        },
        2: {
          activeStatus: 0,
          currentPage: 1,
          pageSize: 12,
          list: [],
          total: []
        },
        3: {
          activeStatus: 0,
          currentPage: 1,
          pageSize: 12,
          list: [],
          total: []
        }
      },
      spinning: false,
      showItemModal: false,
      activeItem: {},
      dataList: {},
      imgVisible: false,
      activeImg: '',
      showCardPos: false
    }
  },
  computed: {
    statusList () {
      const arr = [0, 1, 2, 3, 4]
      const index = arr.indexOf(this.dataGroup[this.activeTab].activeStatus)
      arr.splice(index, 1)
      return arr
    },
    userInfo () {
      return this.$store.getters.userInfo
    }
  },
  mounted () {
    this.burry('14')
    if (this.userInfo.authentication_status == '2') {
      this.loadList()
    }
  },
  methods: {
    showDeleteConfirm (index) {
      this.delIndex = index
      const self = this
      this.$confirm({
        centered: true,
        content: '确定删除该素材',
        onOk () {
          self.delElement()
        },
        cancelText: '取消',
        okText: '确定',
        onCancel () {}
      })
    },
    async delElement () {
      const params = {
        id: this.dataGroup[this.activeTab].list[this.delIndex].id
      }
      await this.$api.texture.delTexture(params)
      await this.getList()
    },
    async tabChange (e) {
      this.activeTab = e
      await this.getList()
    },
    async statusChange (e) {
      this.dataGroup[this.activeTab].activeStatus = e.key
      const dataSend = {
        page: 1
      }
      this.dataGroup[this.activeTab].currentPage = 1
      await this.getList(dataSend)
    },
    async loadList () {
      this.loading = true

      await this.getList()
      this.loading = false
    },
    async getList (params) {
      // if (this.activeTab == 1) { // 临时屏蔽场景
      //   return
      // }
      this.spinning = true
      const dataSend = {
        category: this.activeTab,
        status: this.dataGroup[this.activeTab].activeStatus,
        page: this.dataGroup[this.activeTab].currentPage,
        pagesize: this.dataGroup[this.activeTab].pageSize
      }
      params = Object.assign(dataSend, params)
      const res = await this.$api.texture.getTextureList({ ...params })
      this.spinning = false
      if (res.status === 'ok') {
        this.dataGroup[params.category].total = res.data.count || 0
        this.dataGroup[params.category].list = res.data.list || []
      }
    },
    async revokeAudit (id) {
      await this.$api.texture.revokeAudit({ id });
      await this.getList();
    },
    // 分页切换
    async allPageChange (page, pageSize) {
      this.dataGroup[this.activeTab].currentPage = page
      const dataSend = {
        page,
        pagesize: pageSize
      }
      await this.getList(dataSend)
    },
    clickItem (item) {
      if (item.is_handle === 0) {
        // 是否可以操作  0不可已 1可以
        this.activeItem = item
        this.showItemModal = true
      } else {
        this.$router.push({ path: '/texture/imageUpload', query: { id: item.id } })
      }
    },
    hide () {
      this.showItemModal = false
    },
    jumpToEditor () {
      this.burry('15')
      this.$router.push('/texture/imageUpload')
      sessionStorage.setItem('list', this.dataGroup[0].list.length)
    },
    showImg (url) {
      this.imgVisible = true
      this.activeImg = url
    },
    goAuthor () {
      this.$router.push({
        path: '/manage/userAuthentication'
      })
    },
    // 显示卡片位置信息
    onCardPosChange (e) {
      this.showCardPos = e.target.checked
    }
  }
}
</script>

<style scoped lang="less">
.package-wrapper {
  height: 540px;
  overflow: auto;

  &::-webkit-scrollbar-track {
    background: none;
  }
  &::-webkit-scrollbar-thumb {
    background: #dddddd;
    border-radius: 4px;
  }
}
.errorIcon {
  color: #F5222D;
  width: 16px;
  height: 16px;
  margin-left: 10px;
  cursor: pointer;
}
.preViewModal {
  .preViewImg {
    max-width: 620px;
  }
}

.container {
  width: 100%;
  margin: 0 auto;
  height: 100%;
  display: block;
  background-color: #ffffff;
  padding-bottom: 30px;
  .notice {
    min-height: 400px;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    font-size: 18px;
    color: #999999;
  }
  .empty-status {
    min-height: 400px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .ant-tabs {
    height: 100%;
  }
  .texture-list {
    display: flex;
    flex-wrap: wrap;
    min-height: 700px;
    padding-bottom: 60px;
    .texture-item {
      // margin-bottom: 8px;
      padding: 24px 30px;
      // height: 334px;
      box-sizing: border-box;

      transition: ease all 0.3s;

      .cover {
        cursor: pointer;
        position: relative;
        margin-bottom: 10px;
        border: 1px solid #f2f2f2;
        display: flex;
        justify-content: center;
        align-content: center;
        width: 200px;
        height: 200px;
        border-radius: 4px;
        overflow: hidden;
        &.card-cover {
          img {
            border-radius: 0px;
          }
          &::after {
            content: '';
            display: block;
            width: 100%;
            height: 100%;
            position: absolute;
            z-index: 7;
            background-color: rgba(0, 0, 0, 0.06);
          }
        }
        .card-bg {
          filter: blur(12px);
          height: 200px;
          object-fit: cover;
        }
        .card-image {
          position: absolute;
          width: 150px;
          height: 200px;
          object-fit: cover;
          z-index: 8;
        }
        &:hover {
          .mask {
            display: block;

            .del-btn {
              display: block;
              position: absolute;
              top: 8px;
              right: 8px;
              z-index: 9;
            }
          }
        }
        .mask {
          display: none;
          position: absolute;
          border-radius: 4px;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          background-color: rgba(0, 0, 0, 0.5);
          justify-content: flex-end;

          .del-btn {
            display: none;
            color: red;
            cursor: pointer;
          }
        }

        img {
          display: block;
          width: 100%;
          height: auto;
          object-fit: cover;
          border-radius: 4px;
        }
      }
      .sort {
        line-height: 1;
        margin-bottom: 4px;
        .sort_name {
          margin-left: 5px;
          width: 24px;
          height: 11px;
          font-size: 12px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #bbbbbb;
          line-height: 24px;
        }
      }

      .name {
        color: #999999;
        font-size: 14px;
        margin-bottom: 4px;
      }
      .price {
        color: #999999;
        font-size: 12px;
        margin-bottom: 4px;
      }
      .copyright {
        color: #999999;
        font-size: 12px;
        line-height: 18px;
        margin-bottom: 10px;
        min-height: 36px;
      }

      .status {
        display: flex;
        align-items: center;
        .status-button {
          flex-shrink: 0;
        }
        .back-button {
          margin-left: 30px;
        }
      }

    }
  }
}

.pagination {
  position: absolute;
  bottom: 0px;
  right: 30px;
}

.title {
  font-family: 'Quicksand', 'Source Sans Pro', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue',
    Arial, sans-serif;
  display: block;
  font-weight: 300;
  font-size: 100px;
  color: #35495e;
  letter-spacing: 1px;
}

.subtitle {
  font-weight: 300;
  font-size: 42px;
  color: #526488;
  word-spacing: 5px;
  padding-bottom: 15px;
}

.links {
  padding-top: 15px;
}
.itemModal {
  .card-preview {
    width: 345px;
    height: 613px;
    position: relative;
    img {
      position: absolute;
      left: 0;
      top: 0;
      width: 345px;
      height: auto;
      display: block;
    }
  }
  .cover {
    width: 120px;
    height: 120px;
    border: 1px solid #f2f2f2;
    border-radius: 4px;
  }
  .element-list {
    display: flex;
    flex-wrap: wrap;
    .element-item {
      height: 180px;
      margin-bottom: 25px;
      &:not(:nth-of-type(5n)) {
        margin-right: 25px;
      }
      .name {
        text-align: left;
        font-size: 14px;
        color: #999999;
        margin-bottom: 24px;
        margin-top: 12px;
        line-height: 24px;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .cover {
        width: 142px;
        height: 142px;
        box-sizing: border-box;
        border: 1px solid #f2f2f2;
        border-radius: 4px;
        position: relative;
        &:hover {
          cursor: pointer;
          border: 1px solid @primary-color;
        }
        img {
          display: block;
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          max-width: 100%;
          max-height: 100%;
        }
      }
    }
  }
}
</style>
